<template>
    <div class="news-content">
        <div class="news-thumb">
            <img :src="image" alt="">
        </div>
        <div class="post-meta">
            <span class="author">{{author}}</span>
        </div>
        <div class="news-inner">
            <h4><a :href="link" target="_blank" style="color: #333;">{{title}}</a></h4>
            <p>{{desc}}</p>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'NewsItem',
        props: {
            image: {
                required: true
            },
            title: {
                required: true
            },
            link: {
                required: true
            },
            desc: {
                required: true
            },
            author: {
                required: true
            }
        },
        data () {
            return {};
        },
        methods: {}
    };
</script>
